/* esm.sh - applesauce-relay@5.2.0/dist/operators/complete-on-eose */
export * from "/*applesauce-relay@5.2.0/esnext/dist/operators/complete-on-eose.mjs";
